import PropTypes from 'prop-types';
import { Card } from 'roo-ui/components';
import { HorizontalRule } from 'components/Layout';
import QffPoints from './QffPoints';
import QbrPoints from './QbrPoints';

const QantasPointsEarnCard = ({ earnedPoints, awardedPoints, qbrPoints, pointsClubTier }) => {
  const hasQffPoints = earnedPoints + awardedPoints > 0;
  const showRule = !!qbrPoints && hasQffPoints;

  return hasQffPoints || qbrPoints ? (
    <Card p={[5, 6]} mb={[5, 8]} display="flex" flexDirection="column" data-hj-suppress>
      {hasQffPoints && <QffPoints earnedPoints={earnedPoints} awardedPoints={awardedPoints} pointsClubTier={pointsClubTier} />}
      {showRule && <HorizontalRule mx={0} my={3} />}
      {!!qbrPoints && <QbrPoints qbrPoints={qbrPoints} />}
    </Card>
  ) : null;
};

QantasPointsEarnCard.defaultProps = {
  earnedPoints: 0,
  awardedPoints: 0,
  qbrPoints: 0,
  pointsClubTier: '',
};

QantasPointsEarnCard.propTypes = {
  earnedPoints: PropTypes.number,
  awardedPoints: PropTypes.number,
  qbrPoints: PropTypes.number,
  pointsClubTier: PropTypes.oneOf(['', 'base', 'plus']),
};

export default QantasPointsEarnCard;
